module.exports = __webpack_public_path__ + "img/cercas.37385758.jpeg";